const my_profile = {
  viewMyClubSeacretProfile: "Δείτε το προφίλ μου ClubSeacret", // translated
  viewMoreDetails: "Δείτε περισσότερες λεπτομέρειες", // translated
  verifiedEmail: "Επαληθευμένο email", // translated
  unverifiedEmail: "Μη επαληθευμένο email", // translated
};

export default my_profile;
